import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LiveOrdersFlow } from "../components/orders/LiveOrdersFlow";
import { useI18n } from "../i18n";

/** Orders route — same Live Orders Flow as Dashboard HQ. */
export default function OrdersPage() {
  const { t } = useI18n();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedId, setSelectedId] = useState<string | null>(
    () => searchParams.get("id")
  );

  const syncSelectionToUrl = useCallback(
    (id: string | null) => {
      const next = new URLSearchParams(searchParams);
      if (id) next.set("id", id);
      else next.delete("id");
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams]
  );

  useEffect(() => {
    setSelectedId(searchParams.get("id"));
  }, [searchParams]);

  const onSelectedIdChange = useCallback(
    (id: string | null) => {
      setSelectedId(id);
      syncSelectionToUrl(id);
    },
    [syncSelectionToUrl]
  );

  return (
    <LiveOrdersFlow
      title={t("orders.title")}
      selectedId={selectedId}
      onSelectedIdChange={onSelectedIdChange}
    />
  );
}
